import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { reject, map } from 'lodash';
import { idify } from '@src/util/idify';
import ClientItem from './ClientItem';
import './styles.scss';

function attachImageUrl(image) {
  return {
    ...image,
    url: image.fullUrl,
  };
}

export default class ClientsList extends PureComponent {
  static propTypes = {
    defaultValues: PropTypes.arrayOf(PropTypes.object),
    onChange: PropTypes.func.isRequired,
  };

  state = {
    items: map(this.props.defaultValues, it => ({ ...it, logo: attachImageUrl(it.logo) })),
    newItem: {},
    uploading: undefined,
  };

  addItem = evt => {
    if (evt) {
      evt.preventDefault();
    }

    this.setState(
      ({ items, newItem }) => ({
        items: [...items, { ...newItem, tempId: `temp-id-${Math.random()}` }],
        newItem: {},
      }),
      this.itemsChanged,
    );
  };

  onChange = (key, value) => {
    this.setState(({ newItem }) => ({ newItem: { ...newItem, [key]: value } }), this.addItem);
  };

  removeItem = item => {
    this.setState(({ items }) => ({ items: reject(items, _item => _item === item) }), this.itemsChanged);
  };

  itemsChanged = () => this.props.onChange(this.state.items);

  render() {
    const { items, newItem } = this.state;
    const addDisabled = !newItem.name || !newItem.logo;

    return (
      <div className="clients-list">
        <ClientItem addDisabled={addDisabled} addItem={this.addItem} item={newItem} onChange={this.onChange} />

        {!!items.length &&
          map(items, item => (
            <ClientItem item={item} itemDisabled key={idify(item) || item.tempId} removeItem={this.removeItem} />
          ))}
      </div>
    );
  }
}
